import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './../styles/InformationSection.css';
import { useMarkdownContent } from '../hooks/useMarkdownContent';

const InformationUsersSection = ({ filePath }) => {
  const { markdownContent, previewContent } = useMarkdownContent(filePath);
  const [showFull, setShowFull] = useState(false);

  return (
    <div className="text-info-users-section">
      <ReactMarkdown>
        {showFull ? markdownContent : previewContent}
      </ReactMarkdown>
      <button className="expand-button" onClick={() => setShowFull(!showFull)}>
        {showFull ? (
          <>
            Show less <FaChevronUp className="text-info-font-style-dark" />
          </>
        ) : (
          <>
            Show more <FaChevronDown className="text-info-font-style-dark" />
          </>
        )}
      </button>
    </div>
  );
};

export default InformationUsersSection;
